import cookie from "vue-cookies";

export const login = (token = ""): void => {
  (cookie as any).set("token", token, null, null, process.env.VUE_APP_BASE_URL);
};
